import {cn} from '../../lib/utils';
import {Icon} from '../Icon/Icon';

import type {IconProps} from '../Icon/Icon';

/** The down chevron of a popover trigger: it flips while the popover is open. Must sit inside a `PopoverTrigger`. */
export function PopoverChevron({className, ...props}: Omit<IconProps, 'name'>) {
  return (
    <Icon
      name="chevron-down"
      data-slot="popover-chevron"
      className={cn(
        'shrink-0 text-fg-tertiary transition-transform duration-200 motion-reduce:transition-none',
        'group-data-popup-open/popover-trigger:rotate-180',
        className
      )}
      {...props}
    />
  );
}
